module.exports = __webpack_public_path__ + "media/landing_page/fss-d8a6426b.jpg";